import Axios from "../../../../../api/axios/Axios";

export const getSavedPops = async (params = {}) => {
  const response = await Axios.get("/api/users/pops/saved", {
    params,
  });

  return response.data;
};

export const getSavedPopStatus = async (popId) => {
  const response = await Axios.get(`/api/users/pops/${popId}/save/status`);

  return response.data;
};

export const savePop = async (popId) => {
  const response = await Axios.post(`/api/users/pops/${popId}/save`);

  return response.data;
};

export const unsavePop = async (popId) => {
  const response = await Axios.delete(`/api/users/pops/${popId}/save`);

  return response.data;
};
